import { useEffect, useState } from "react";
import { useUserAuthStore } from "../../context/useUserAuthStore";
import Modal from "../ui/Modal";

function UserForm({ initial, onSubmit, isAdmin }) {
  const [form, setForm] = useState(
    initial ?? {
      firstname: "",
      lastname: "",
      email: "",
      password: "",
      cellNumber: "",
      status: "active",
      role: "driver",
    }
  );

  const change = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  return (
    <form
      className="form-grid"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(form);
      }}
    >
      <input
        name="firstname"
        placeholder="First name"
        value={form.firstname}
        onChange={change}
        required
      />
      <input
        name="lastname"
        placeholder="Last name"
        value={form.lastname}
        onChange={change}
        required
      />
      <input
        name="email"
        placeholder="Email"
        type="email"
        value={form.email}
        onChange={change}
        required
        disabled={!!initial} // prevent email changes
      />

      {!initial && (
        <input
          name="password"
          placeholder="Password"
          type="password"
          value={form.password}
          onChange={change}
          required
        />
      )}

      <input
        name="cellNumber"
        placeholder="Cell number"
        value={form.cellNumber}
        onChange={change}
      />

      {/* Role (admin only) */}
      {isAdmin && (
        <select name="role" value={form.role} onChange={change}>
          <option value="driver">Driver</option>
          <option value="admin">Admin</option>
        </select>
      )}

      {/* Status */}
      <select name="status" value={form.status} onChange={change}>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>

      <div className="form-actions">
        <button type="submit">Save</button>
      </div>
    </form>
  );
}

export default function UsersTab() {
  const {
    users,
    fetchUsers,
    registerUser,
    updateUser,
    deleteUser,
    loading,
    currentUser,
  } = useUserAuthStore();

  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);

  useEffect(() => {
    if (currentUser?.role === "admin" && !users.length) {
      fetchUsers();
    }
  }, [users.length, fetchUsers, currentUser]);

  // 🔒 Non-admins blocked
  if (currentUser?.role !== "admin") {
    return (
      <div className="p-4 text-gray-600">
        You do not have permission to manage users.
      </div>
    );
  }

  if (loading) return <div>Loading users...</div>;

  return (
    <div>
      <div className="toolbar">
        <button
          onClick={() => {
            setEditing(null);
            setOpen(true);
          }}
        >
          + New User
        </button>
      </div>

      <div className="table">
        <div className="table-row table-head">
          <div>First</div>
          <div>Last</div>
          <div>Email</div>
          <div>Role</div>
          <div>Status</div>
          <div>Cell</div>
          <div></div>
        </div>

        {users.map((u) => (
          <div className="table-row" key={u.id}>
            <div>{u.firstname}</div>
            <div>{u.lastname}</div>
            <div>{u.email}</div>
            <div>{u.role}</div>
            <div>{u.status}</div>
            <div>{u.cellNumber || "-"}</div>

            <div className="row-actions">
              <button
                onClick={() => {
                  setEditing(u);
                  setOpen(true);
                }}
              >
                Edit
              </button>

              {/* Prevent deleting self */}
              {u.id !== currentUser.id && (
                <button
                  className="danger"
                  onClick={() => deleteUser(u.id)}
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
          setEditing(null);
        }}
        title={editing ? "Edit User" : "New User"}
      >
        <UserForm
          initial={editing}
          isAdmin={currentUser.role === "admin"}
          onSubmit={(data) => {
            if (editing) {
              updateUser(editing.id, data);
            } else {
              registerUser(data);
            }
            setOpen(false);
            setEditing(null);
          }}
        />
      </Modal>
    </div>
  );
}
